import loadable from '@loadable/component';
import LoadingComponent from 'components/Loaders/LoadingComponent';

const ComposeWeightsLoadable = loadable(
  () => import(/* webpackChunkName: 'admin-ComposeWeights' */ './ComposeWeights'),
  {
    fallback: <LoadingComponent />,
  }
);

export default ComposeWeightsLoadable;
